import $axios from "../api/accessor";
import { $api } from "../api/api";
import { toast } from "react-toastify";
import { isObjectString } from "../extentions/checker";

interface CalculatePriceRequest {
  package_ids: number[];
  dropoff_lat: number;
  dropoff_lon: number;
  scheduled_time: string;
  street: string;
  city: string;
}
interface OrderWoltRequest extends CalculatePriceRequest {
  branch_id: number;
  customer: string;
  phone: string;
  phone_prefix: string;
  description?: string | null;
  street: string;
  amount: number;
}
export const WoltService = {
  async calculatePrice(data: CalculatePriceRequest) {
    let response = await $axios
      .post($api("get_wolt_calculated_price"), data, {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        console.log(isObjectString(err.response.data.content));
        if (!isObjectString(err.response.data.content)) {
          toast.error(err.response.data.content);
        } else {
          const content = JSON.parse(err.response.data.content);
          console.log(content);
          toast.error(content.detail[0].msg);
        }
      });
    return {
      data: response?.data ? response?.data : {},
    };
  },

  async order(data: OrderWoltRequest) {
    let response = await $axios
      .post($api("order_wolt"), data, {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((error) => {
        throw error.response ? error.response.data : error.message;
      });
    return response.data;
  },
  async getAllOrders(url?: string) {
    let response = await $axios
      .get(url || $api("get_all_orders_wolt"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data.data : [],
      status: response?.status,
    };
  },
  async getWoltOrderDetails(orderId: number) {
    let response = await $axios
      .get($api("get_all_order_details_wolt", { order_id: orderId }), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
